<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="1300px">
    <template v-slot:activator="{ on }">
      <v-tooltip left v-on="on">
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="addButton"
            v-on="on"
            dark
            small
            fab
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar condomínio</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="closeForm">close</v-icon>
      </v-system-bar>

      <v-card-title class="mb-0 pb-0">
        <span class="title grey--text text--darken-2">
          {{ setTitleForm(formData.id) }}
        </span>
      </v-card-title>

      <v-card-text class="mt-0 pt-0">
        <v-form
          style="min-height: 400px"
          ref="condominiumForm"
          v-model="validForm"
          lazy-validation
          class="mt-0 pt-0"
        >
          <v-tabs
            id="condominiumTab"
            v-model="active"
            color="white"
            dark
            slider-color="primary"
            class="pt-4"
          >
            <v-tab
              v-for="tab in tabs"
              :replace="true"
              :key="tab.id"
              :value="tab.id"
              class="grey--text text--darken-1"
              :disabled="validateLogTab(tab.name)"
            >
              {{ tab.name }}
            </v-tab>

            <v-tab-item :key="0" class="mt-3">
              <v-card flat>
                <h2 class="body-2 pl-3 text-sm-left ml-3 pt-2" v-if="!viewForm">
                  <v-icon
                    v-if="formData.avatar"
                    @click="resetImage"
                    class="delImage mr-2"
                    >delete_forever</v-icon
                  >Logotipo
                </h2>

                <v-card-text class="pt-1">
                  <v-layout row wrap white>
                    <v-flex md3 sm6>
                      <div id="preview" class="imgBox grey lighten-3">
                        <img
                          :src="formData.avatar"
                          height="200"
                          v-if="formData.avatar"
                        />
                        <span v-if="!formData.avatar">200 x 200</span>
                      </div>
                      <v-flex xs12>
                        <div style="position: relative">
                          <v-text-field
                            :disabled="viewForm"
                            label="Selecione uma imagem"
                            @click="pickFile"
                            v-model="formData.imageName"
                            prepend-icon="attach_file"
                          ></v-text-field>
                          <input
                            id="logoIpt"
                            type="file"
                            style="display: none"
                            ref="image"
                            accept="image/*"
                            @change="onFilePicked"
                          />
                        </div>
                      </v-flex>
                    </v-flex>
                    <v-flex md9 sm6>
                      <v-layout row wrap white px-3>
                        <v-flex sm12 md12 pl-4 mb-0>
                          <v-text-field
                            :disabled="viewForm"
                            class="mt-0"
                            v-model="formData.name_company"
                            :rules="$store.state.formRules.required"
                            label="Razão social"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm12 md6 pl-4>
                          <v-text-field
                            :disabled="viewForm"
                            v-model="formData.name_fantasy"
                            :rules="$store.state.formRules.required"
                            label="Nome fantasia"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm12 md6 pl-4>
                          <v-text-field
                            :disabled="viewForm"
                            :mask="
                              formData.document.length <= 11
                                ? '###.###.###-########'
                                : '##.###.###/####-##'
                            "
                            :rules="$store.state.formRules.cpfCnpjRules"
                            v-model="formData.document"
                            label="CPF/CNPJ"
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm12 md6 pl-4>
                          <v-text-field
                            :disabled="viewForm"
                            type="text"
                            v-model="formData.email"
                            label="Email"
                            :rules="$store.state.formRules.emailRules"
                            @keydown.enter.prevent
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm12 md6 pl-4>
                          <v-text-field
                            :disabled="viewForm"
                            type="text"
                            v-model="formData.condominium_tell"
                            label="Telefone"
                            :mask="
                              formData.condominium_tell.length < 15
                                ? '(##) ####-#####'
                                : '(##) #####-####'
                            "
                            :rules="$store.state.formRules.required"
                            @keydown.enter.prevent
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm4 pr-3 pl-4>
                          <v-menu
                            v-model="valDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="viewForm"
                                clearable
                                v-model="certificate_expiration_date_formated"
                                mask="##/##/####"
                                return-masked-value
                                label="Vencimento do certificado digital"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              no-title
                              v-model="formData.certificate_expiration_date"
                              @input="valDate = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs7 pl-4>
                          <v-autocomplete
                            :disabled="viewForm"
                            :rules="$store.state.formRules.requiredSelect"
                            v-model="formData.representative_id"
                            :items="prepositories"
                            item-text="representative_name"
                            item-value="id"
                            label="Selecione o preposto"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs1>
                          <v-btn
                            @click="showPrepository(formData.representative_id)"
                            flat
                            icon
                            color="primary"
                            :disabled="!formData.representative_id"
                          >
                            <v-icon>visibility</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="1">
              <v-card flat>
                <v-card-text>
                  <AddressCondominium
                    :disableFields="viewForm"
                    class="addressCondominium"
                    :loadAddress="(data) => loadAddress(data)"
                    :forwShow="dialogShow"
                    :editedData="addressData"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <!--<v-tab-item :key="2">
              <v-card flat>
                <v-card-text>
                  <Areas
                    :disableFields="viewForm"
                    :removeArea="(id) => removeArea(id)"
                    :tabInd="active"
                    :dataAreas="areasData"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>-->
            <v-tab-item :key="3">
              <PostingPeriod
                :disableFields="viewForm"
                :forwShow="dialogShow"
                :updatePostingPeriod="updatePostingPeriod"
                :accounting_year="accounting_year"
                :confirmDelPostingPeriod="confirmDelPostingPeriod"
                :confirmToogleStatusItem="confirmToogleStatusItem"
              />
            </v-tab-item>
            <v-tab-item :key="4">
              <FinancialForm
                :disableFields="viewForm"
                ref="financialForm"
                :forwShow="dialogShow"
                :editedData="financialData"
                @getFinancialData="updateFinancialData"
                :loadFinancialForm="loadFinancialForm"
              />
              <v-layout wrap>
                <v-flex xs12>
                  <p
                    class="pl-2 text-xs-left mb-0 mt-3 body-2 grey--text text--darken-2"
                    style="font-weight:600;"
                  >Responsáveis</p>
                </v-flex>
                <v-flex xs12>
                  <Responsible2LevelsFinancial
                    :disableFields="viewForm"
                    :dialog="dialogShow"
                    urlDel="/api/notifyFinancial/"
                    :clearDataEdit="clearDataEdit"
                    @updateResponsibleList="updateFinancialNotify"
                    :dataEdit="formData.notifyFinancial"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item :key="5">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="!viewForm"
                    style="right: 30px; top: 40px"
                    class="mt-0 mr-0"
                    v-on="on"
                    absolute
                    dark
                    small
                    fab
                    top
                    right
                    color="light-blue darken-4"
                    @click="responsibleDialog = true"
                  >
                    <v-icon style="font-size: 24px"
                      >supervised_user_circle</v-icon
                    >
                  </v-btn>
                </template>
                <span>Responsáveis</span>
              </v-tooltip>
              <v-dialog v-model="responsibleDialog" max-width="850">
                <v-card>
                  <v-card-title class="headline">Responsáveis</v-card-title>
                  <v-card-text>
                    <v-flex xs5 pl-2 pt-0>
                      <v-text-field
                        min="1"
                        type="number"
                        v-model="mandate_alert"
                        :suffix="mandate_alert > 1 ? 'dias antes' : 'dia antes'"
                        label="Avisar sobre vencimento"
                        :rules="$store.state.formRules.required"
                        required
                      ></v-text-field>
                    </v-flex>
                    <Responsible2LevelsSyndicationMandate
                      :dialog="dialogShow"
                      urlDel="/api/notifyMandate/"
                      :clearDataEdit="clearDataEditSindication"
                      @updateResponsibleList="updateSindcationMandateNotify"
                      :dataEdit="formData.notifySindcationMandate"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <v-btn
                      color="blueGrey darken-1"
                      flat
                      @click="responsibleDialog = false"
                    >Cancelar</v-btn>-->
                    <v-btn
                      color="primary"
                      flat
                      @click="responsibleDialog = false"
                      >Aplicar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <SyndicationMandate
                :disableFields="viewForm"
                :forwShow="dialogShow"
                :updateSyndicationMandate="updateSyndicationMandate"
                :syndicationMandateList="syndicationMandateList"
                :confirmDelMandate="confirmDelMandate"
              />
            </v-tab-item>
            <v-tab-item>
              <Responsible2LevelsCondominium
                :disableFields="viewForm"
                :outUsers="true"
                :dialog="dialogShow"
                urlDel="/api/condominium_notify/destroy/"
                :clearDataEdit="clearDataEditCondominium"
                @updateResponsibleList="updateCondominiumNotify"
                :dataEdit="formData.notify_documents_contracts"
              />
            </v-tab-item>
            <v-tab-item>
              <ToggleChecklist 
                :condominiumId="condominiumId"
                :dialogShow="dialogShow"
              />
            </v-tab-item>
            <v-tab-item>
              <SystemLogs :tableData="tableLogs" />
            </v-tab-item>
          </v-tabs>
        </v-form>
      </v-card-text>

      <v-card-actions style="border-top: 1px solid #eee">
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="closeForm"
          >Cancelar</v-btn
        >
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as moment from 'moment'
import AddressCondominium from '../common/AddressForm'
import Areas from './Areas'
import PostingPeriod from './PostingPeriod'
import Responsible from '../common/Responsible'
import FinancialForm from './FinancialForm'
import SyndicationMandate from './SyndicationMandate'
import SystemLogs from '@/components/SystemLogs.vue'
import ToggleChecklist from '@/components/common/ToggleChecklist.vue'
import { logsCondominium } from '@/services/condominiuns'

const defaultCondominiumForm = {
  certificate_expiration_date: new Date().toISOString().substr(0, 10),
  condominium_tell: '',
  email: '',
  representative_id: '',
  representative_name: '',
  id: null,
  user_id: null,
  imageFile: '',
  condominium_id: null,
  name_company: '',
  name_fantasy: '',
  document: '',
  avatar: '',
  imageName: '',
  building: [],
  accounting_year: [],
  syndicationMandateList: [],
  financial: {
    alert_date: '1',
    adjustment_date: '',
    value: '',
    financial_value: '',
    adjustment_index: '',
    thirteenth_charge: false
  },
  address: {
    number_address: '',
    address_id: '',
    type: '',
    zipcode: '',
    address: '',
    district: '',
    state: '',
    city: '',
    complement: ''
  }
}

export default {
  name: 'CondominiumFormDlg',

  components: {
    SyndicationMandate,
    'Responsible2LevelsFinancial': Responsible,
    'Responsible2LevelsSyndicationMandate': Responsible,
    'Responsible2LevelsCondominium': Responsible,
    Areas,
    PostingPeriod,
    AddressCondominium,
    FinancialForm,
    SystemLogs,
    ToggleChecklist,
  },

  props: {
    showPrepository: Function,
    prepositories: Array,
    addButton: Boolean,
    openForm: Function,
    closeForm: Function,
    saveCondominium: Function,
    dialog: Boolean,
    editFormData: Object,
    getCondominiums: Function,
    reopenFormFilled: Function
  },

  data () {
    return {
      mandate_alert: '1',
      responsibleDialog: false,
      notifyFinancial: [],
      notifySindcationMandate: [],
      notify_documents_contracts: [],
      valDate: false,
      prepository: [],
      viewForm: false,
      tabs: [
        { id: 0, name: 'Condomínio' },
        { id: 1, name: 'Endereço' },
        //{ id: 2, name: 'Áreas' },
        { id: 3, name: 'Período contábil' },
        { id: 4, name: 'Financeiro' },
        { id: 5, name: 'Mandatos de síndico' },
        { id: 6, name: 'Alertas' },
        { id: 8, name: 'Checklist' },
        { id: 9, name: 'Logs' }
      ],
      active: 1,
      validForm: true,
      formData: { ...defaultCondominiumForm },
      addressData: { ...defaultCondominiumForm.address },
      accounting_year: [...defaultCondominiumForm.accounting_year],
      syndicationMandateList: [
        ...defaultCondominiumForm.syndicationMandateList
      ],
      areasData: [...defaultCondominiumForm.building],
      financialData: { ...defaultCondominiumForm.financial },
      tableLogs: []
    }
  },

  computed: {
    certificate_expiration_date_formated: {
      get () {
        return this.formData.certificate_expiration_date
          ? moment(this.formData.certificate_expiration_date).format(
            'DD/MM/YYYY'
          )
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 10) return
          let arrs = value.split('/')
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`
          if (!moment(date).isValid()) {
            this.formData.certificate_expiration_date = new Date()
              .toISOString()
              .substr(0, 10)
            return
          }
          this.formData.certificate_expiration_date = date
        } else {
          this.formData.certificate_expiration_date = ''
        }
      }
    },
    dialogShow () {
      return this.dialog
    },
    condPermissions() {
      return this.$store.state.permissions.permissions.condominiums
    },
    condominiumId() {
      return this.formData.id ? this.formData.id : 0
    }
  },

  watch: {
    dialogShow (edit) {
      if (edit) {
        const tabs = document.querySelectorAll('#condominiumTab .v-tabs__item')
        tabs[1].click()
        tabs[0].click()

        if (this.editFormData) {
          if (this.$props.editFormData.view) {
            this.viewForm = true

            this.getLogs()
          } else {
            this.viewForm = false
          }

          if (this.editFormData.financial) {
            let priceFormated
            let valLength = this.editFormData.financial.financial_value.toString().split('.')[1]

            if (!valLength) {
              priceFormated = `${this.editFormData.financial.financial_value}.00`
            } else if (valLength && valLength.length < 2) {
              priceFormated = `${this.editFormData.financial.financial_value}0`
            } else {
              priceFormated = this.editFormData.financial.financial_value
            }
            document.getElementById('adjustmentValue').value = priceFormated

            this.editFormData.notifyFinancial = this.editFormData.notify_financial
          }

          this.editFormData.condominium_tell = this.editFormData
            .condominium_tell
            ? this.editFormData.condominium_tell
            : ''
          this.editFormData.notify_documents_contracts = this.editFormData.user_condominium_notification
          this.editFormData.notifySindcationMandate = this.editFormData.notify_mandate
          this.formData = {
            ...this.editFormData
          }

          this.addressData = { ...this.editFormData.address }
          this.editFormData.financial
            ? (this.financialData = { ...this.editFormData.financial })
            : {}
          this.areasData = [...this.editFormData.building]
          this.accounting_year = [...this.editFormData.accounting_year]
          this.syndicationMandateList = this.editFormData
            .syndication_mandate_list
            ? [...this.editFormData.syndication_mandate_list]
            : []

          this.$refs.condominiumForm.resetValidation()
        }
      } else {
        this.viewForm = false

        this.getCondominiums()
        this.resetCondominiumForm()
      }
    }
  },

  methods: {
    delItem (data, url, type) {
      let obj = {
        url: url,
        query: '',
        method: type === 'mandate' ? 'delete' : 'delete'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Item removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        if (type !== 'mandate') {
          let index = this.accounting_year.findIndex((accYear) => {
            return accYear.date_init === data.date_init
          })
          this.accounting_year.splice(index, 1)
        } else {
          let index = this.syndicationMandateList.findIndex((mandate) => {
            return mandate.date_init === data.date_init
          })
          this.syndicationMandateList.splice(index, 1)
        }
      })
    },

    async getLogs () {
      if (this.editFormData.id) {
        const response = await logsCondominium(this.editFormData.id)

        this.tableLogs = response
      }
    },

    validateLogTab (name) {
      if (name === 'Logs') {
        if (!this.viewForm) {
          return true
        }

        if (this.$store.state.permissions.permissions.condominiums && !this.$store.state.permissions.permissions.condominiums.edit) {
          return true
        }
      }

      if (name === 'Ficha Técnica' || name === 'Checklist') {
        if (!this.editFormData) return true
      }

      return false
    },

    confirmDelMandate (data) {
      if (data.id) {
        let url = '/api/syndicationMandate/' + data.id
        let obj = {
          message: `Você deseja excluir o mandato de síndico?`,
          title: 'Excluir mandato de síndico',
          callback: (_) => {
            this.delItem(data, url, 'mandate')
          },
          type: 'warning',
          btConfirm: { name: 'Sim', show: true },
          btCancel: { name: 'Não', show: true }
        }
        this.$store.commit('confirmMessage/showConfirmMessage', obj)
        return
      }
      let index = this.syndicationMandateList.findIndex((mandate) => {
        return mandate.date_init === data.date_init
      })
      this.syndicationMandateList.splice(index, 1)
    },

    changeStatus (data, url) {
      let obj = {
        url: url,
        query: '',
        method: 'post'
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }

        let opts = {
          message: response.data.message,
          type: 'success'
        }

        this.$store.commit('showAlert', opts)

        this.reopenFormFilled(this.editFormData.id)
      })
    },

    confirmToogleStatusItem (data) {
      if (data.id) {
        let url = '/api/accounting_year/disable/' + data.id
        let type = data.status ? 'desativar' : 'ativar'
        
        let obj = {
          message: `Você deseja ${type} o período contábil?`,
          title: `${data.status ? 'Desativar' : 'Ativar'} período contábil`,
          callback: (_) => {
            this.changeStatus(data, url, 'period')
          },
          type: 'warning',
          btConfirm: { name: 'Sim', show: true },
          btCancel: { name: 'Não', show: true }
        }

        this.$store.commit('confirmMessage/showConfirmMessage', obj)
      }
    },

    confirmDelPostingPeriod (data) {
      if (data.id) {
        let url = '/api/accounting_year/destroy/' + data.id
        let obj = {
          message: `Você deseja excluir o período contábil?`,
          title: 'Excluir período contábil',
          callback: (_) => {
            this.delItem(data, url, 'period')
          },
          type: 'warning',
          btConfirm: { name: 'Sim', show: true },
          btCancel: { name: 'Não', show: true }
        }
        this.$store.commit('confirmMessage/showConfirmMessage', obj)
        return
      }
      let index = this.accounting_year.findIndex((accYear) => {
        return accYear.date_init === data.date_init
      })
      this.accounting_year.splice(index, 1)
    },

    updateCondominiumNotify (data) {
      if (data.remove) {
        let index = this.notify_documents_contracts.findIndex(
          (user) => {
            return user.user_id === data.user_id && user.level === data.level
          }
        )

        this.notify_documents_contracts.splice(index, 1)

        return
      }
      this.notify_documents_contracts.push(data)
    },

    clearDataEditCondominium (id) {
      let index = this.notify_documents_contracts.findIndex(
        (doc) => doc.id === id
      )
      this.notify_documents_contracts.splice(index, 1)
    },

    setTitleForm (id) {
      let returnTitle

      if (id) {
        returnTitle = 'Editar condomínio'
      } else {
        returnTitle = 'Novo condomínio'
      }

      if (this.viewForm) {
        returnTitle = 'Visualização'
      }

      return returnTitle
    },

    updateSindcationMandateNotify (data) {
      if (data.remove) {
        let index = this.notifySindcationMandate.findIndex(
          (user) => {
            return user.user_id === data.user_id && user.level === data.level
          }
        )

        this.notifySindcationMandate.splice(index, 1)

        return
      }
      this.notifySindcationMandate.push(data)
    },

    clearDataEditSindication (id) {
      let index = this.notifySindcationMandate.findIndex((doc) => doc.id === id)
      this.notifySindcationMandate.splice(index, 1)
    },

    updateFinancialNotify (data) {
      if (data.remove) {
        let index = this.notifyFinancial.findIndex(
          (user) => {
            return user.user_id === data.user_id && user.level === data.level
          }
        )
        this.notifyFinancial.splice(index, 1)

        return
      }
      this.notifyFinancial.push(data)
    },

    clearDataEdit (id) {
      let index = this.formData.notifyFinancial.findIndex(
        (doc) => doc.id === id
      )
      this.formData.notifyFinancial.splice(index, 1)
    },

    updateFinancialData (data) {
      this.formData.financial = data
    },

    updatePostingPeriod (data) {
      if (data.id || data.editing) {
        let index = this.accounting_year.findIndex(
          (accYear) => accYear.id === data.id
        )
        this.accounting_year.splice(index, 1)
      }

      this.accounting_year.push(data)
    },

    updateSyndicationMandate (data) {
      if (data.id || data.editing) {
        let index = this.syndicationMandateList.findIndex(
          (mandate) => mandate.id === data.id
        )
        this.syndicationMandateList.splice(index, 1)
      }

      this.syndicationMandateList.push(data)
    },

    loadFinancialForm (data) {
      console.log(data)
    },

    loadAddress (data) {
      let obj = {
        district: data.bairro,
        zipcode: data.cep,
        city: data.localidade,
        address: data.logradouro,
        state: data.uf
      }

      this.addressData = { ...obj }
    },

    resetImage () {
      document.getElementById('logoIpt').value = ''
      this.formData.imageName = ''
      this.formData.avatar = ''
      this.formData.imageFile = ''
    },

    pickFile () {
      this.$refs.image.click()
    },

    onFilePicked (e) {
      const files = e.target.files

      if (files[0] !== undefined) {
        this.formData.imageName = files[0].name
        if (this.formData.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.formData.avatar = fr.result
          this.formData.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.formData.imageName = ''
        this.formData.imageFile = ''
        this.formData.avatar = ''
      }
    },

    validTabs (tabs, btTabs, additionalRules) {
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].getElementsByClassName('v-messages__message').length) {
          btTabs[i].classList.add('tabError')
        } else {
          btTabs[i].classList.remove('tabError')
        }
      }
      if (additionalRules.length) {
        for (let n = 0; n < additionalRules.length; n++) {
          if (!additionalRules[n].model.length) {
            btTabs[additionalRules[n].ind].classList.add('tabError')
          } else {
            btTabs[additionalRules[n].ind].classList.remove('tabError')
          }
        }
      }
    },

    doSave () {
      if (!this.$refs.condominiumForm.validate()) {
        let tabs = document.querySelectorAll('#condominiumTab .v-window-item')
        let btTabs = document.querySelectorAll('#condominiumTab .v-tabs__item')
        //let additionalRules = [
          //{
            //model: this.areasData,
            //ind: 2
          //}
        //]
        //setTimeout((_) => {
          //this.validTabs(tabs, btTabs, additionalRules)
        //}, 200)
        return
      }
      //if (!this.areasData.length) {
      //  let tabArea = document.querySelectorAll(
      //    '#condominiumTab .v-tabs__item'
      //  )[2]
      //  tabArea.classList.add('tabError')
      //  return
      //}
      this.$refs.financialForm.updateFinancialForm()
      this.formData.building = this.areasData.map((area) => {
        if (area.id && area.id.toString().indexOf('temp-') > -1) {
          area.id = null
        }
        return area
      })
      this.formData.address = this.addressData

      const callback = function () {
        this.$props.closeForm()
      }

      this.formData.accounting_year = this.accounting_year
      this.formData.syndicationMandateList = this.syndicationMandateList
      this.formData.mandate_alert = this.mandate_alert
      if (this.notifyFinancial && this.notifyFinancial.length) {
        this.formData.notify_financial = this.notifyFinancial
      }

      if (this.notifySindcationMandate && this.notifySindcationMandate.length) {
        this.formData.notify_mandate = this.notifySindcationMandate
      }

      if (
        this.notify_documents_contracts &&
        this.notify_documents_contracts.length
      ) {
        this.formData.notify_documents_contracts = this.notify_documents_contracts
      } else {
        let obj = {
          message:
            'É necessário cadastra ao menos 1 responsável para receber os alertas do condomínio.',
          title: 'Cadastrar responsável',
          callback: (_) => {
            const tabs = document.querySelectorAll(
              '#condominiumTab .v-tabs__item'
            )
            tabs[5].click()
          },
          type: 'warning',
          btConfirm: { name: 'Ok', show: true },
          btCancel: { name: 'Não', show: false }
        }
        this.$store.commit('confirmMessage/showConfirmMessage', obj)
        return
      }

      this.formData.financial.financial_value = parseFloat(
        this.formData.financial.value.split('.').join('').replace(',', '.')
      )

      this.$props.saveCondominium(this.formData, callback)
    },

    resetDialog () {
      this.dialogShow = !this.dialogShow
    },

    resetCondominiumForm () {
      document.getElementById('logoIpt').value = ''

      document.getElementById('adjustmentValue').value = 0
      if (this.formData.financial) this.formData.financial.value = 0

      this.notifyFinancial = []
      this.notifySindcationMandate = []
      this.notify_documents_contracts = []
      this.$refs.condominiumForm.resetValidation()
      this.formData = { ...defaultCondominiumForm }
      this.addressData = { ...defaultCondominiumForm.address }
      this.accounting_year = [...defaultCondominiumForm.accounting_year]
      this.syndicationMandateList = [
        ...defaultCondominiumForm.syndicationMandateList
      ]
      this.areasData = [...defaultCondominiumForm.building]
      this.financialData = { ...defaultCondominiumForm.financial }
    }
  }
}
</script>

<style>
.labelIcon {
  position: absolute;
  left: 3px;
  top: 15px;
  cursor: pointer;
}
.labelIcon i {
  font-size: 18px;
}
.iptFile input {
  opacity: 0;
}
.imgBox {
  overflow: hidden;
  display: flex;
  width: 200px;
  height: 200px;
  align-items: center;
  justify-content: center;
  margin: auto;
}
.delImage {
  font-size: 18px;
  color: #c62828 !important;
  cursor: pointer;
}
.addressCondominium .flex {
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 20px;
}
#condominiumTab .v-tabs__bar {
  border-bottom: 1px solid #eee !important;
}

#condominiumTab .v-tabs__item.tabError {
  color: #c62828;
}
#condominiumTab .v-tabs__item.tabError::before {
  content: "*";
  color: #c62828;
}
</style>
